import { useTranslation } from 'react-i18next';
import IntegrationsTable from 'pages/integrations/components/integrationTable/IntegrationsTable';
import { IntegrationCategory } from 'models/InternalIntegrationSetting';
import TabHeader from '../../components/tabHeader/TabHeader';

const IntegrationsInsuranceAndScreeningTab = () => {
  const { t } = useTranslation();

  return (
    <section>
      <TabHeader
        tabName={t('pageIntegrations.tabNames.insurance-and-screening')}
      />
      <IntegrationsTable
        category={IntegrationCategory.INSURANCE_AND_SCREENING}
      />
    </section>
  );
};

export default IntegrationsInsuranceAndScreeningTab;
